import React, { useState, useEffect } from "react";
import "./Chatbot.css";
import chatbotyes from "../../Images/chatbot_yes.svg";
import chatbotno from "../../Images/chatbot_no.svg";
import { insertPrompt } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { toast } from "react-toastify";
import CbLogo from "../../Images/CbLogo.svg";
import moment from "moment";

function ChatbotFeedback({ prompt, response, setRemarks, setIsFeedbackMode, remarks, sendFeedback, promptId }) {
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const [isFeedBackReceived,setIsFeedBackReceived]=useState(false);

  const [feedbackResponses, setFeedbackResponses] = useState([]);

  var time = moment(new Date()).format("h:mm A");

  useEffect(()=>{
    if(response){
      setFeedbackResponses([]);
      setIsFeedBackReceived(false);
    }
  }, [response]);

  const postFeedBack = async (feedBackresponse, remarks) => {
    const postData = {
      promptLogId: promptId,
      prompt: prompt,
      promptResponse: JSON.stringify(response),
      userId: 0,
      status: response !== null || response !== undefined ? true : false,
      ipAddress: "",
      feedback: feedBackresponse,
      remarks:remarks,
      createdDate: new Date().toISOString(),
    };
    try {
      await sbaAxios({
        url: insertPrompt,
        method: "post",
        data: postData,
      });
      toast.success("Feedback saved successfully.");
    } catch (e) {
      toast.error("Unable to save Feedback.");
    }
  };

  useEffect(()=>{
    if(sendFeedback){
      postFeedBack(false, remarks);
      setFeedbackResponses([
        ...feedbackResponses,
        {
          prompt: remarks,
          headline:
            "Thank you for your feedback! I appreciate your help in improving my responses. I'll learn from this to provide better results in the future.",
          component: <></>,
        },
      ]);
      setIsFeedbackMode(false);
      setIsFeedBackReceived(true);
    }
  }, [sendFeedback]);

  const postNegativeFeedBack=(remarks)=>{
    postFeedBack(false, remarks);
    setFeedbackResponses([
      ...feedbackResponses,
      {
        prompt: remarks,
        headline:
          "Thank you for your feedback! I appreciate your help in improving my responses. I'll learn from this to provide better results in the future.",
        component: <></>,
      },
    ]);
    setIsFeedbackMode(false);
    setIsFeedBackReceived(true);
  }

  const handleFeedback = (feedback) => {
    if (feedback) {
      setFeedbackResponses([
        // ...feedbackResponses,
        {
          prompt: (
            <>
              <span style={{ marginRight: "10px" }}>
                <img src={chatbotyes}></img>
              </span>
              Yes
            </>
          ),
          headline:
            "Great! I'm happy I could help. Let me know if you need anything else!",
          component: <></>,
        },
      ]);
      postFeedBack(true, "");
      setIsFeedBackReceived(true);
    }

    if (!feedback) {
      setFeedbackResponses([
        //...feedbackResponses,
        {
          prompt: (
            <>
              <span style={{ marginRight: "10px" }}>
                <img src={chatbotno}></img>
              </span>
              No
            </>
          ),
          headline:
            "Would you like to let me know what's off or missing in this response?",
          component: <NegativeFeedback setRemarks={setRemarks} postNegativeFeedBack={postNegativeFeedBack} />,
        },
      ]);
      setIsFeedbackMode(true);
    }
  };
  return (
    <>
      <div
        className="p-3 bg-white life-science rounded mt-2"
        style={{ width: "50vw", display: "flex", flexDirection: "column" }}
      >
        <div className="d-flex gap-2">
          <p className="m-0 fs-4 fw-semibold text-dark">
            Is this information helpful and accurate?
          </p>
        </div>
        <p>
          Your feedback is important to me! If you notice any discrepancies or
          missing details in my response, please let me know so I can improve
          the accuracy and quality of the results I provide
        </p>
        <div>
          <button
            className="p-2 outline-success mx-4 rounded-pill"
            onClick={() => {
              handleFeedback(true);
            }}
            style={{ marginRight: "20px" }}
            disabled={isFeedBackReceived}

          >
            {/* <i class="fa-solid fa-check text-success "></i> */}
            <span style={{ marginRight: "10px" }}>
              <img src={chatbotyes}></img>
            </span>
            Yes
          </button>
          <button
            className="p-2 outline-danger mx-1 rounded-pill"
            onClick={() => {
              handleFeedback(false);
            }}
            disabled={isFeedBackReceived}
          >
            {/* <i class="fa-solid fa-x text-danger px-2"></i> */}
            <span style={{ marginRight: "10px" }}>
              <img src={chatbotno}></img>
            </span>
            No
          </button>
        </div>
      </div>
      {!isFeedbackSent && (
        <>
          <div>
            {feedbackResponses?.length > 0 &&
              feedbackResponses.map((item, index) => (
                <div key={index}>
                  <div className="row mt-3">
                    <div className="col-md-8 d-flex justify-content-end ms-auto">
                      <div className="d-flex flex-column mx-2">
                      </div>
                      <div className="card p-3" style={{ width: "auto" }}>
                        <div className="d-flex  gap-2" >
                          <i class="fa fa-user" aria-hidden="true"></i>
                          <p class="text-dark fw-bold">You</p>
                          {/* <i
                            class="fa fa-pencil ms-auto"
                            aria-hidden="true"
                          ></i> */}
                        </div>
                        <div className="d-flex mt-2"style={{minWidth:"120px"}}>
                          <p>{item.prompt}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-end"></div>
                      <p className="col-md-12 d-flex justify-content-end">
                        {time}
                      </p>
                    </div>
                  </div>

                  <div
                    className="p-3 bg-white life-science rounded mt-2"
                    style={{
                      width: "50vw",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="d-flex gap-2">
                      <img
                        className="py-2 align-self-start logo-icon"
                        src={CbLogo}
                        alt="Logo"
                      />
                      <p className="m-0 fs-4 fw-semibold text-dark">
                        Asset Edge
                      </p>
                    </div>
                    <p>{item.headline}</p>
                    {item.component} {/* Rendering stored JSX */}
                  </div>
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
}

export default ChatbotFeedback;


const NegativeFeedback = ({setRemarks,postNegativeFeedBack}) => {
  return(
    <>
      <div className="d-inline-flex gap-2">
  <button
    className="p-2 outline-success rounded-pill w-auto"
    onClick={() => postNegativeFeedBack("Data Outdated.")}
  >
    Data Outdated
  </button>
  <button
    className="p-2 outline-success rounded-pill w-auto"
    onClick={() => postNegativeFeedBack("Inaccurate Data.")}
  >
    Inaccurate Data
  </button>
  <button
    className="p-2 outline-success rounded-pill w-auto"
    onClick={() => postNegativeFeedBack("Missing information.")}
  >
    Missing Information
  </button>
  <button
    className="p-2 outline-success rounded-pill w-auto"
    onClick={() => postNegativeFeedBack("Formatting issue.")}
  >
    Formatting Issue
  </button>
  <button
    className="p-2 outline-success rounded-pill w-auto"
    onClick={() => setRemarks("Others")}
  >
    Others (Write Your own)
  </button>
</div>
    </>
  )
};